var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('Metadata'), _c('div', {
    staticClass: "validators card"
  }, [_c('StakingMetadata', {
    on: {
      "toggle": _vm.handleToggle
    }
  }), _c('div', {
    staticClass: "controls"
  }, [_c('div', {
    staticClass: "filter_count"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.search.length > 0 && _vm.matchedValidators,
      expression: "search.length > 0 && matchedValidators"
    }]
  }, [_vm._v(" " + _vm._s(_vm._f("pluralize")(_vm.matchedValidators.length.toLocaleString('en-US'), 'result')) + " found ")])]), _c('div', {
    staticClass: "filter_input_container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.search,
      expression: "search"
    }],
    staticClass: "filter",
    attrs: {
      "type": "text",
      "placeholder": "Filter by Node ID"
    },
    domProps: {
      "value": _vm.search
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value;
      }
    }
  })])]), _c('div', {
    staticClass: "headers"
  }, [_c('p', [_vm._v("Rank")]), _c('p', [_vm._v(" Node ID "), _c('Tooltip', {
    attrs: {
      "content": "Node ID of validator participating in the consensus protocol"
    }
  })], 1), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('Tooltip', {
    attrs: {
      "content": "Amount of DCM staked by this validator"
    }
  }), _vm._v("Stake ")], 1), _vm.$vuetify.breakpoint.smAndUp ? _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('Tooltip', {
    attrs: {
      "content": "Percentage of DCM concentrated up to this validator ranking"
    }
  }), _vm._v("Cumulative Stake ")], 1) : _vm._e()]), _vm.validators.length === 0 ? _c('div', {
    staticClass: "empty_table"
  }, [_c('p', [_vm._v("No " + _vm._s(_vm.toggle) + " Validators")])]) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.search.length === 0,
      expression: "search.length === 0"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.validators.length > 0,
      expression: "validators.length > 0"
    }]
  }, _vm._l(_vm.paginatedValidators, function (v) {
    return _c('ValidatorRow', {
      key: v.nodeID + v.stakeAmount,
      staticClass: "validator",
      attrs: {
        "validator": v,
        "cumulative-stake": _vm.cumulativeStake[v.rank - 1]
      }
    });
  }), 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.search.length > 0,
      expression: "search.length > 0"
    }]
  }, _vm._l(_vm.matchedValidators, function (v) {
    return _c('ValidatorRow', {
      key: v.nodeID + v.stakeAmount,
      staticClass: "validator",
      attrs: {
        "validator": v,
        "cumulative-stake": _vm.cumulativeStake[v.rank - 1]
      }
    });
  }), 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.search.length === 0,
      expression: "search.length === 0"
    }],
    staticClass: "pagination_container"
  }, [_c('ValidatorPaginationControls', {
    attrs: {
      "total": _vm.totalValidatorsCount,
      "limit": _vm.limit
    },
    on: {
      "change": _vm.handleChange
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }